import { Controller } from "@hotwired/stimulus"

// Filters a long list in place by a search query and an optional source, and
// shows only the first few items until the list is expanded. Items carry the
// text to match in data-name and their source in data-source.
export default class extends Controller {
  static targets = ["item", "query", "source", "empty", "more", "count"]
  static values = {
    limit: { type: Number, default: 8 },
    source: { type: String, default: "" },
    expanded: { type: Boolean, default: false }
  }

  connect() {
    this.apply()
  }

  filter() {
    this.apply()
  }

  selectSource(event) {
    this.sourceValue = event.params.source || ""
    this.sourceTargets.forEach((button) => {
      button.setAttribute("aria-pressed", button === event.currentTarget)
    })
    this.apply()
  }

  expand() {
    this.expandedValue = true
    this.apply()
  }

  // The query field sits inside the editor's form, where Enter would save it.
  ignoreEnter(event) {
    event.preventDefault()
  }

  apply() {
    const query = this.hasQueryTarget ? this.queryTarget.value.trim().toUpperCase() : ""
    const showAll = this.expandedValue || query.length > 0
    let matched = 0

    this.itemTargets.forEach((item) => {
      const matches = (!query || item.dataset.name.toUpperCase().includes(query)) &&
        (!this.sourceValue || item.dataset.source === this.sourceValue)

      if (matches) matched++
      this.toggle(item, !matches || (!showAll && matched > this.limitValue))
    })

    if (this.hasEmptyTarget) this.toggle(this.emptyTarget, matched > 0)
    if (this.hasMoreTarget) this.toggle(this.moreTarget, showAll || matched <= this.limitValue)
    if (this.hasCountTarget) this.countTarget.textContent = matched
  }

  // A class rather than the hidden attribute, which display utilities like flex override.
  toggle(element, hidden) {
    element.classList.toggle("hidden", hidden)
  }
}
